const builder = (domain, document = window.document) => {
  const doc = document;

  const getValue = (name, source = doc.cookie) => {
    const indice = source.indexOf(name);

    if (indice === -1 || !name) return '';

    let idxTo = source.indexOf(';', indice);

    const idxAmp = source.indexOf('&', indice);
    if ((idxTo > idxAmp && idxAmp !== -1) || (idxTo === -1 && idxAmp !== -1)) idxTo = idxAmp;
    if (idxTo === -1) idxTo = source.length;

    const idFrom = indice + name.length + 1;

    return unescape(source.substring(idFrom, idxTo));
  };

  const createCookieString = (name, value, seconds, path) => {
    const strExpires = seconds ? `expires=${(new Date(Date.now() + (seconds * 1000))).toGMTString()}; ` : '';
    const strDomain = (domain === 'localhost') ? '' : `domain=${domain}; `;
    const strPath = path ? `path=${path}; ` : '';

    return `${name}=${value}; ${strExpires}${strDomain}${strPath}`.trim();
  };

  const setValue = (name, value, seconds = 853200, path = '/') => { doc.cookie = createCookieString(name, value, seconds, path); };

  return { getValue, setValue };
};

module.exports = builder(window.document.domain.split(':', 1).pop(), window.document);
module.exports.builder = builder;



// WEBPACK FOOTER //
// ./~/@ln/cookie/cookie.js